import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./components/auth/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import ProfileCompletionGuard from "./components/auth/ProfileCompletionGuard";
import Navigation from "./components/layout/Navigation";
import LandingPage from "./components/pages/LandingPage";
import Login from "./components/pages/Login";
import ForgotPassword from "./components/pages/ForgotPassword";
import ResetPassword from "./components/pages/ResetPassword";
import SetPassword from "./components/pages/SetPassword";
import TherapistDashboard from "./components/pages/CalendarView";
import TherapistInsights from "./components/pages/Reports";
import TherapistAccountTools from "./components/pages/ProfileManagement";
import TherapistAvailability from "./components/pages/SOAPNotes";
import BookingsManagement from "./components/pages/BookingsManagement";
import CheckInsManagement from "./components/pages/CheckInsManagement";
import AvailabilityManagement from "./components/pages/AvailabilityManagement";
import { Toaster } from "./components/ui/sonner";
import CookieConsentManager from "./components/CookieConsentManager";

const App = () => {
  const wrapWithNavigation = (Component) => (
    <ProtectedRoute>
      <ProfileCompletionGuard>
        <Navigation>
          <Component />
        </Navigation>
      </ProfileCompletionGuard>
    </ProtectedRoute>
  );

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/set-password" element={<SetPassword />} />

            {/* Protected Routes */}
            <Route path="/dashboard" element={wrapWithNavigation(TherapistDashboard)} />
            <Route
              path="/reports"
              element={wrapWithNavigation(TherapistInsights)}
            />
            <Route
              path="/soap-notes"
              element={wrapWithNavigation(TherapistAvailability)}
            />
            <Route
              path="/profile"
              element={wrapWithNavigation(TherapistAccountTools)}
            />
            {/* <Route path="/bookings" element={wrapWithNavigation(BookingsManagement)} /> */}
            <Route
              path="/check-ins"
              element={wrapWithNavigation(CheckInsManagement)}
            />
            <Route
              path="/availability"
              element={wrapWithNavigation(AvailabilityManagement)}
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
        <CookieConsentManager />
      </AuthProvider>
    </div>
  );
};

export default App;
